import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای تنظیمات چاپ لیبل

در این صفحه می‌توانید قالب و تنظیمات چاپگر برای پرینت لیبل‌های بارکد را پیکربندی کنید.

## ۱. انتخاب قالب
قالب‌های مختلف لیبل (سایز، چیدمان) قابل انتخاب و تنظیم هستند.

## ۲. اتصال به چاپگر
مشخصات چاپگر بارکدزن خود را پیکربندی کنید تا سیستم در زمان ورود به انبار به صورت خودکار لیبل صادر کند.

export default Layout;
